<!--
  - Copyright (c) 2018 BarD Software s.r.o
  -->

<template>
    <div class="team-projects">
        <div class="header">
            <h4 class="invisible">Projects</h4>
        </div>
        <div class="team-info-tab-row d-flex flex-wrap" id="teams-tab-row">
            <ul class="nav nav-pills flex-nowrap flex-grow-1" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" href="#"
                       data-toggle="pill"
                       aria-selected="true">Projects</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" v-on:click="$parent.showTeamMembers">People</a>
                </li>
            </ul>
            <div class="flex-fill d-flex justify-content-end">
                <button v-bind:class="{'d-none': !hasProjects()}"
                        class="btn btn-attention btn-new-item btn-new-project"
                        data-target="#project-new-modal"
                        data-toggle="modal">
                    New Project
                </button>
            </div>
        </div>
        <div class="team-info-body pt-3">
            <div v-bind:class="{'d-none': hasProjects()}" class="w-100">
                <div class="justify-content-center">
                    <div class="text-center">
                        <i class="fa fa-5x fa-tasks mt-5 mb-2"></i><br>
                        <button class="btn btn-attention btn-new-item btn-new-project"
                                data-target="#project-new-modal"
                                data-toggle="modal">
                            New Project
                        </button>
                    </div>
                </div>
                <div class="mt-3 justify-content-center">
                    <p class="text-muted text-center">Project is a file which you work with in desktop GanttProject. All team members will have read-write access to projects owned by the team.<br>
                        <a href="https://help.ganttproject.biz/t/what-is-a-team-in-ganttproject-cloud" target="_blank">Learn more</a></p>
                </div>
            </div>
            <div v-bind:class="{'d-none': !hasProjects()}" class="w-100">
                <div id="project-list" class="list-group" role="tablist">
                    <div class="project-item list-group-item list-group-item-action d-flex"
                         @click="onProjectSelected(p)"
                         v-for="p in projects" :key="p.refid"
                         v-bind="{'data-project': p.refid}">
                        <project-item :project="p"></project-item>
                    </div>
                </div>
            </div>
        </div>

        <project-lock-modal
                id="project-lock-modal"
                v-bind:team="team_"
                v-bind:project="project">
        </project-lock-modal>

        <project-remove-modal
                id="project-remove-modal"
                v-bind:team="team_"
                v-bind:project="project"
        >
        </project-remove-modal>
        <project-new-modal
                id="project-new-modal"
                v-bind:team="team_"
        >
        </project-new-modal>
    </div>
</template>

<script lang="ts">
import {reactive} from 'vue';
import {Prop, Watch, Component, Vue} from 'vue-facing-decorator';
import TeamInfo from './TeamInfo.vue';
import {ProjectDto, TeamDto} from '../Teams';
import {SelectionModel} from '../utils/Ui';
import {DashboardSelection, getDashboardSelection, updateProject} from '../Dashboard';

import $ from 'jquery';

@Component
export default class TeamProjects extends Vue {

  @Prop
  public team: TeamDto | null = null;

  private team_: TeamDto | null = null;

  private projectSelectionModel: SelectionModel<ProjectDto> = new SelectionModel<ProjectDto>(
      '#project-list',
      '.project-item',
      'data-project',
      (a, b) => a.refid === b.refid,
  );
  private project: ProjectDto | null = null;
  private projects = reactive<ProjectDto[]>([]);
  private afterUpdates: MutableList<JQueryDeferred<any>> = [];

  public mounted() {
    this.setTeam(this.team);
    const teamInfo = this.$parent;
    // TODO(smell): shall this be in the parent, or always true, or something else?
    if (teamInfo) {
      $('#member-pill').on('click', () => (teamInfo as TeamInfo).showTeamMembers());
    }
    // TODO(smell): move this to the project properties component?
    $('#project-properties-modal').on('shown.bs.modal', () => $('#modal-project-name').focus());
  }

  public updated() {
    this.$nextTick(() => {
      this.afterUpdates.map((deferred) => deferred.resolve());
      this.afterUpdates = [];
    });
  }

  public hasProjects(): boolean {
    return this.team_ ? this.team_.projects.length > 0 : false;
  }

  public clear() {
    this.team_ = null;
    this.projects = [];
  }

  public setProject(project: ProjectDto | null) {
    this.project = project;
    if (!project) {
      return;
    }

    const idx = this.projects.findIndex((p) => p.refid === project.refid);
    this.projects[idx] = this.project;
  }

  public onProjectSelected(project: ProjectDto) {
    updateProject(project);
    let selection = getDashboardSelection();
    selection.project = project;
  }

  public setTeam(val: TeamDto | null) {
    if (!val) {
      this.clear();
      return;
    }

    this.team_ = val;

    this.projects = val.projects as MutableList<ProjectDto>;
    const id2model = (id) => this.projects.find((p) => p.refid === id);
    this.afterUpdates.push(this.projectSelectionModel.init(id2model, (p) => this.setProject(p)));

    // TODO update history?
  }
}
</script>
<style scoped>
.project-item {
  cursor: pointer;
}
</style>
